/**
 * @Author: Lzp <liuzp@xinlongmail.com>
 * @Date: 2021-09-29 14:27:21
 * @LastEditors: Lzp
 * @LastEditTime: 2021-09-29 14:27:21
 */

import * as request from '@/utils/request'
const BASE_URL = 'paihuo/project'
export default {
  /**
   * getPaihuoProjectList
   * @description 查看列表
   * @author Lzp
   * @date 2021/9/29
   * @param {*} data
   * @returns
   */
  getPaihuoProjectList(data) {
    return request.get(`${BASE_URL}/list`, data)
  },

  /**
   * viewPaihuoProject
   * @description 详情
   * @author Lzp
   * @date 2021/9/29
   * @returns promise
   */
  viewPaihuoProject(data) {
    return request.get(`${BASE_URL}/view/${data}`)
  },
  
  /**
   * examinePaihuoProject
   * @description 审核
   * @author Lzp
   * @date 2021/9/29
   * @param {*} data
   * @returns
   */
  examinePaihuoProject(id, data) {
    return request.put(`${BASE_URL}/examine/${id}`, data)
  }
}